var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "x-mark_svg__x-mark",
    viewBox: "0 0 14 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".x-mark_svg__cls-1{fill:inherit}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x-mark_svg__Path_31168",
    d: "M7 14a7 7 0 117-7 7.008 7.008 0 01-7 7zM7 1a6 6 0 106 6 6.007 6.007 0 00-6-6zm0 0",
    className: "x-mark_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "x-mark_svg__Path_31169",
    d: "M151.786 152.288a.5.5 0 01-.354-.147l-5-5a.5.5 0 01.707-.707l5 5a.5.5 0 01-.353.854zm0 0",
    className: "x-mark_svg__cls-1",
    transform: "translate(-142.286 -142.288)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "x-mark_svg__Path_31170",
    d: "M146.786 152.286a.5.5 0 01-.353-.854l5-5a.5.5 0 01.707.707l-5 5a.5.5 0 01-.354.147zm0 0",
    className: "x-mark_svg__cls-1",
    transform: "translate(-142.286 -142.286)"
  })));
}

export default SvgXMark;